const SUBNAVBARTOGGLE = "SUBNAVBARTOGGLE" as const;
export const subNavbarToggle = (diff: any) => ({
  type: SUBNAVBARTOGGLE,
  payload: diff,
});

type StoreAction = ReturnType<typeof subNavbarToggle>;

type StoreState = {
  subNavbarOpen: boolean;
};
const initialState: StoreState = {
  subNavbarOpen: true,
};

function nav_store(
  state: StoreState = initialState,
  action: StoreAction
): StoreState {
  switch (action.type) {
    case SUBNAVBARTOGGLE:
      return { ...state, subNavbarOpen: action.payload };
    default:
      return state;
  }
}

export default nav_store;
